/* eslint-disable prettier/prettier */

export const teamConstants = {
    FETCHING_MYTEAM_API_SUCCESS: 'FETCHING_MYTEAM_API_SUCCESS',
    FETCHING_MYTEAM_API_FAILED: 'FETCHING_MYTEAM_API_FAILED',
    FETCHING_REFFERAL_API_SUCCESS: 'FETCHING_REFFERAL_API_SUCCESS',
    FETCHING_REFFERAL_API_FAILED: 'FETCHING_REFFERAL_API_FAILED',
}